var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mediaType.indexOf('image') != -1)?_c('img',{style:(_vm.style),attrs:{"src":_vm.imageUrl}}):(_vm.mediaType.indexOf('video') != -1)?_c('img',{style:(_vm.style),attrs:{"src":_vm.videoUrl}}):(
      _vm.mediaType.indexOf('.document') != -1 ||
        _vm.mediaType.indexOf('msword') != -1 ||
        _vm.mediaType.indexOf('.docx') != -1 ||
        _vm.mediaType.indexOf('.doc') != -1
    )?_c('img',{style:(_vm.style),attrs:{"src":_vm.wordUrl}}):(
      _vm.mediaType.indexOf('.sheet') != -1 ||
        _vm.mediaType.indexOf('.ms-excel') != -1 ||
        _vm.mediaType.indexOf('.xlsx') != -1 ||
        _vm.mediaType.indexOf('.xls') != -1
    )?_c('img',{style:(_vm.style),attrs:{"src":_vm.excelUrl}}):(_vm.mediaType.indexOf('pdf') != -1)?_c('img',{style:(_vm.style),attrs:{"src":_vm.pdfUrl}}):(
      _vm.mediaType.indexOf('text/plain') != -1 || _vm.mediaType.indexOf('.txt') != -1
    )?_c('img',{style:(_vm.style),attrs:{"src":_vm.txtUrl}}):(
      _vm.mediaType.indexOf('powerpoint') != -1 ||
        _vm.mediaType.indexOf('presentation') != -1
    )?_c('img',{style:(_vm.style),attrs:{"src":_vm.pptUrl}}):(
      _vm.mediaType.indexOf('zip') != -1 ||
        (_vm.mediaType == '' && _vm.getFileType(_vm.fileName))
    )?_c('img',{style:(_vm.style),attrs:{"src":_vm.archiveUrl}}):_c('img',{style:(_vm.style),attrs:{"src":_vm.otherUrl}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18814f41","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/fileImage/fileImage.vue
// module id = null
// module chunks = 